<template>
    <div id="commentSection">
        <div class="commentWrapper">
            <h4>Kommentar</h4>
            <textarea v-if="editable" rows="8" v-model="textarea" @input="$emit('input', textarea)"></textarea>
            <div v-else class="externComment">{{ comment }}</div>
        </div>
        <Navbox>
            <template slot="noStyling">
                <AdaButton v-if="editable" @click="saveDashboard" icon="icon-save" type="createButton" title="Speichern"
                           :loading="loading"></AdaButton>
                <AdaButton icon="icon-download" type="createButton" title="Excel Export"
                           :disabled="$store.state.trackingList.reporting_loading"
                           @click="exportTrackinglist" :loading="excelLoading"></AdaButton>
                <AdaButton v-if="$route.name === 'showDashboard'" icon="icon-spreadsheet" type="createButton blue"
                           title="Reporting-Liste" :to="route"></AdaButton>
                <AdaButton v-if="$route.name === 'showReporting'" icon="icon-dashboard" type="createButton blue"
                           title="Dashboard" :to="route"></AdaButton>
                <AdaButton v-if="editable" icon="icon-share" type="createButton grey" title="Teilen"
                           @click="openShareDialog"></AdaButton>
            </template>
        </Navbox>
        <ShareDialog :show="showShareDialog" v-if="showShareDialog" @close="showShareDialog = false"></ShareDialog>
    </div>
</template>

<script>
import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import Navbox from "../../components/navBox/Navbox";
import AdaButton from "../../components/buttons/AdaButton";
import ShareDialog from "../../components/dialog/ShareDialog";

const TrackingListRepository = RepositoryFactory.get('trackingLists');

export default {
    name: "DashboardCommentSection",
    components: {
        ShareDialog,
        AdaButton,
        Navbox
    },
    props: {
        campaign: Object,
        editable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            textarea: null,
            showShareDialog: false,
            excelLoading: false,
            loading: false,
            fnExport: null,
            fnDashboard: null
        }
    },
    mounted() {
        this.fnExport = () => {
            this.exportTrackinglist(true);
        };
        this.fnDashboard = () => {
            this.loading = false;
        };
        this.$root.$on('exportTrackingList', this.fnExport);
        this.$root.$on('saveDashboardFinished', this.fnDashboard);
    },
    beforeDestroy() {
        this.$root.$off('exportTrackingList', this.fnExport);
        this.$root.$off('saveDashboardFinished', this.fnDashboard);
    },
    computed: {
        route() {
            let ret = '/campaigns/' + this.$route.params.id;
            if (this.$route.name === "showDashboard") {
                ret += '/reporting';
            } else if (this.$route.name === "showReporting") {
                ret += '/dashboard';
            }
            return ret;
        },
        icon() {
            if (this.$route.name === "showDashboard") {
                return 'icon-spreadsheet';
            } else {
                return 'icon-dashboard';
            }
        },
        formulas() {
            let ret = this.$store.getters['trackingList/formulas'];
            if (ret.findIndex(x => x.name === 'video_sum') !== -1) ret.splice(ret.findIndex(x => x.name === 'video_sum'), 1);
            if (ret.findIndex(x => x.name === 'expand_sum') !== -1) ret.splice(ret.findIndex(x => x.name === 'expand_sum'), 1);
            return ret;
        },
        comment() {
            return this.$store.state.campaign.campaign.comment;
        }
    },
    created() {
        this.textarea = this.comment;
    },
    methods: {
        openShareDialog() {
            this.showShareDialog = true;
        },
        async exportTrackinglist(clickedFromHeader) {
            clickedFromHeader ? this.$root.$emit('excelLoader', true) : this.excelLoading = true;
            let body = {
                trackingList: this.$store.state.trackingList.data,
                campaign: this.$store.state.campaign.campaign,
                formulas: this.formulas,
                reporting: this.$store.getters['trackingList/reporting'],
                isIntern: typeof this.$route.query.key === 'undefined'
            };
            try {
                let key = this.$route.query.key;
                const {data} = await TrackingListRepository.exportTrackingList(this.campaign.mediums[0].tracking_list_id,
                    body);
                let blob = new Blob([data], {type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Report.xlsx';
                link.click();
                if (key) {
                    await this.$router.push({query: {key: key}});
                }
                clickedFromHeader ? this.$root.$emit('excelLoader', false) : this.excelLoading = false;
            } catch (e) {
                console.error(e);
                clickedFromHeader ? this.$root.$emit('excelLoader', false) : this.excelLoading = false;
            }

        },
        saveDashboard() {
            this.loading = true;
            this.$root.$emit('saveDashboard');
        }
    }
}
</script>

<style lang="scss" scoped>

#commentSection {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    margin-top: 2rem;

    ::v-deep #navbox {
        width: 20%;
        margin-top: 25px;
        margin-left: 5px;
        margin-bottom: 5px;

        > div:nth-child(n+3) {
            margin-top: 10px;
        }

        .icon {
            font-size: 20px;
        }

        .createButton {
            padding: 5px;
        }
    }
}

.commentWrapper {
    width: 78%;

    textarea {
        width: 100%;
        border-color: $grey;
        padding: 10px;
        resize: vertical;
        word-break: break-word;
    }

    .externComment {
        width: 95%;
        border-bottom: 1px solid $grey;
        min-height: 85px;
        padding-bottom: 10px;
    }
}

@media (max-width: 767px) {
    .commentWrapper, .externComment {
        width: 100%;
    }
    #commentSection {

        display: block;
        margin-top: 8rem;

        ::v-deep #navbox {
            width: 100%;
        }
    }

}
</style>